export enum LinkEntity {
Benefit,
Questionnaire,
EntityHistory,
Modification,
}
